import {
	defAction
}from "../../../helpers/defaultAction"
import api from './api'
import helpSectionConstants from "./constants"

export const helpSectionActions = {
	getHelps,
	getHelpTags,
	getActualHelpTags,
	updateHelpTag,
	createHelpTag,
	deleteHelpTag,
	restoreHelpTag,
	createHelp,
	deleteHelp,
	restoreHelp,
	getOneHelp,
	updateHelp,
	clear
}

function getHelps(values){
	const dispatchObj = {
		constants : helpSectionConstants.GET_HELPS,
		service   : {
			func   : api.getHelps,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getHelpTags(values){
	const dispatchObj = {
		constants : helpSectionConstants.GET_HELP_TAGS,
		service   : {
			func   : api.getHelpTags,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getActualHelpTags(values){
	const dispatchObj = {
		constants : helpSectionConstants.GET_HELP_TAGS,
		service   : {
			func   : api.getActualHelpTags,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function updateHelpTag(values){
	const dispatchObj = {
		constants : helpSectionConstants.UPDATE_HELP_TAG,
		service   : {
			func   : api.updateHelpTag,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function createHelpTag(values){
	const dispatchObj = {
		constants : helpSectionConstants.CREATE_HELP_TAG,
		service   : {
			func   : api.createHelpTag,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function deleteHelpTag(values){
	const dispatchObj = {
		constants : helpSectionConstants.DELETE_HELP_TAG,
		service   : {
			func   : api.deleteHelpTag,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function restoreHelpTag(values){
	const dispatchObj = {
		constants : helpSectionConstants.RESTORE_HELP_TAG,
		service   : {
			func   : api.restoreHelpTag,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function createHelp(values){
	const dispatchObj = {
		constants : helpSectionConstants.CREATE_HELP,
		service   : {
			func   : api.createHelp,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function deleteHelp(values){
	const dispatchObj = {
		constants : helpSectionConstants.DELETE_HELP,
		service   : {
			func   : api.deleteHelp,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function restoreHelp(values){
	const dispatchObj = {
		constants : helpSectionConstants.RESTORE_HELP,
		service   : {
			func   : api.restoreHelp,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getOneHelp(values){
	const dispatchObj = {
		constants : helpSectionConstants.GET_ONE_HELP,
		service   : {
			func   : api.getOneHelp,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function updateHelp(values){
	const dispatchObj = {
		constants : helpSectionConstants.UPDATE_HELP,
		service   : {
			func   : api.updateHelp,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clear(){
	return (dispatch) => dispatch({
		type: helpSectionConstants.CLEAR
	})
}